import type { ComponentProps } from "react"

export default function TransactionOther(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M10.9688 9C10.9688 9.38938 10.8533 9.77002 10.637 10.0938C10.4206 10.4175 10.1132 10.6699 9.75341 10.8189C9.39367 10.9679 8.99782 11.0069 8.61592 10.9309C8.23402 10.855 7.88322 10.6675 7.60788 10.3921C7.33255 10.1168 7.14504 9.76598 7.06908 9.38408C6.99312 9.00218 7.0321 8.60633 7.18111 8.24659C7.33012 7.88685 7.58246 7.57937 7.90622 7.36304C8.22998 7.14672 8.61062 7.03125 9 7.03125C9.52199 7.03177 10.0224 7.23935 10.3915 7.60845C10.7606 7.97755 10.9682 8.47801 10.9688 9ZM3.375 7.03125C2.98562 7.03125 2.60498 7.14672 2.28122 7.36304C1.95746 7.57937 1.70512 7.88685 1.55611 8.24659C1.4071 8.60633 1.36812 9.00218 1.44408 9.38408C1.52004 9.76598 1.70755 10.1168 1.98288 10.3921C2.25822 10.6675 2.60902 10.855 2.99092 10.9309C3.37282 11.0069 3.76867 10.9679 4.12841 10.8189C4.48815 10.6699 4.79563 10.4175 5.01196 10.0938C5.22829 9.77002 5.34375 9.38938 5.34375 9C5.34324 8.47801 5.13565 7.97755 4.76655 7.60845C4.39745 7.23935 3.89699 7.03177 3.375 7.03125ZM14.625 7.03125C14.2356 7.03125 13.855 7.14672 13.5312 7.36304C13.2075 7.57937 12.9551 7.88685 12.8061 8.24659C12.6571 8.60633 12.6181 9.00218 12.6941 9.38408C12.77 9.76598 12.9575 10.1168 13.2329 10.3921C13.5082 10.6675 13.859 10.855 14.2409 10.9309C14.6228 11.0069 15.0187 10.9679 15.3784 10.8189C15.7382 10.6699 16.0456 10.4175 16.262 10.0938C16.4783 9.77002 16.5938 9.38938 16.5938 9C16.5932 8.47801 16.3856 7.97755 16.0165 7.60845C15.6474 7.23935 15.147 7.03177 14.625 7.03125Z"
        fill={fill}
      />
    </svg>
  )
}
